import React from "react";

import * as _ from "lodash";

const TextArea = ({ input, meta, ...otherProps }) => {
  const inputElementRef = React.createRef();

  return (
    <div className="form-group">
      {otherProps.label && <label>{otherProps.label}</label>}
      <textarea
        ref={inputElementRef}
        className={`form-control ${otherProps.inputClass} ${
          meta.error && meta.touched ? "is-invalid" : ""
        }`}
        {...input}
        onChange={e => {
          if (otherProps.onChange) otherProps.onChange(e);
          input.onChange(e);
        }}
        autoCapitalize={otherProps.autoCapitalize || "off"}
        autofill={otherProps.autofill}
        placeholder={otherProps.placeholder}
      ></textarea>
      {meta.error && meta.touched && (
        <div className="invalid-feedback">{meta.error}</div>
      )}
    </div>
  );
};

export { TextArea };
